class PluginModuleRegistry {

    constructor() {
        this.provided = new Map()
        this.targeted = new Map()
    }

    /**
     * Register a plugin provided module (class) that can be used to export
     * specific plugin functionality to other plugins. If a consumerPluginId
     * is provided only that plugin will consume, or use, this module. This
     * is used for when a plugin provides well defined extension points.
     *
     * @param {string} moduleId - Provided module id
     * @param {object} module - Actual module
     * @param {object} targetId - Optional target id that identifies the consumer of this module
     */
    addPluginModule(moduleId, module, targetId = false) {
        if (!targetId) {
            this.provided.set(moduleId, module)
        } else {
            module.__namespace = moduleId

            const targetedModules = this.targeted.has(targetId) ? this.targeted.get(targetId) : []
            targetedModules.push(module)

            this.targeted.set(targetId, targetedModules)
        }
    }

    /**
     * Return a fresh instance of a specific plugin provided module
     *
     * @param {string} moduleId Module id
     *
     * @return {object|null}
     */
    getPluginModule(moduleId) {
        const module = this.provided.get(moduleId)

        if (typeof module === 'function' && /^\s*class\s+/.test(module.toString())) { // Is class
            return new module()
        } else {
            return module !== undefined ? module : null
        }
    }

    /**
     * Get all modules targeted at a specific consumer
     *
     * @param {string} targetId Target id of the consumer
     */
    getPluginModulesForTarget(targetId) {
        const modules = this.targeted.has(targetId) ? this.targeted.get(targetId) : []

        return modules.map((module) => {
            if (typeof module === 'function' && /^\s*class\s+/.test(module.toString())) { // Is class
                if (Object.getPrototypeOf(module).name === 'Component') {
                    return module
                } else {
                    return new module()
                }
            }
            else {
                return module
            }
        })
    }

}

export {PluginModuleRegistry}
